import mailingProfileService from './services/mailing-profile.service';

export const MAILING_PROFILE_LIST = 'mailingProfile/MAILING_PROFILE_LIST';
export const CREATE_MAILING_PROFILE = 'mailingProfile/CREATE_MAILING_PROFILE';
export const UPDATE_MAILING_PROFILE = 'mailingProfile/updATE_MAILING_PROFILE';

const initialState = {
  profiles: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_MAILING_PROFILE: {
      const profile = action.payload;
      let profiles = state.profiles;

      profiles = profiles.concat([profile]);
      
      return {
        ...state,
        profiles,
      };
    }
    case UPDATE_MAILING_PROFILE: {
      const profile = action.payload;
      const profiles = state.profiles;
      const index = profiles.findIndex(({id}) => id === profile.id);

      if (index > -1) {
        profiles[index] = profile;
      }
      
      return {
        ...state,
        profiles,
      };
    }
    case MAILING_PROFILE_LIST: {
      return {
        ...state,
        profiles: action.payload
      };
    }
    default:
      return state
  }
}

export const loadMailingProfileList = () => {
  return (dispatch, getState) => {
    return mailingProfileService.getMailingProfiles()
      .then((list) => {
        dispatch({
          type: MAILING_PROFILE_LIST,
          payload: list
        });

        return list;
      });
  };
};

export const createMailingProfile = (profileData) => {
  return (dispatch, getState) => {

    return mailingProfileService.createMailingProfile(profileData)
      .then((profile) => {
        dispatch({
          type: CREATE_MAILING_PROFILE,
          payload: profile
        });

        return profile;
      });
  };
};

export const updateMailingProfile = (id, profileData) => {
  return (dispatch, getState) => {

    return mailingProfileService.updateMailingProfile(id, profileData)
      .then((updatedprofile) => {
        dispatch({
          type: UPDATE_MAILING_PROFILE,
          payload: updatedprofile
        });

        return updatedprofile;
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/mailing-profile.js